import { INIT, USER_LOGIN, RESET_LOGIN, REGISTER_USER } from '../actions/auth';

const initialState = {
  userStatus: 'USER_INIT',
  userInfo: {},
};

function init(state, action) {
  const { login, password, token } = action;
  state.userStatus = token ? 'USER_REGISTERED' : 'USER_UNREGISTERED';
  state.userInfo = { ...state.userInfo, login, password, token };
  return { ...state };
}

function userLogin(state, action) {
  const { login, password, token } = action;
  if (token) {
    state.userStatus = 'USER_LOGIN';
    state.userInfo = { ...state.userInfo, login, password, token };
  } else {
    state.userStatus = 'USER_FORBIDDEN';
  }
  return { ...state };
}

function registerUser(state, action) {
  const { login, password } = action;
  state.userInfo = { ...state.userInfo, login, password };
  return { ...state };
}

export default function reduceAuth(state = initialState, action) {
  switch (action.type) {
    case INIT:
      return init(state, action);
    case USER_LOGIN:
      return userLogin(state, action);
    case RESET_LOGIN:
      return { ...state, userStatus: 'USER_UNREGISTERED' };
    case REGISTER_USER:
      return registerUser(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js